export const SET_LATEST_KYC_CASE = 'SET_LATEST_KYC_CASE';
export const SET_CURRENT_KYC_TIER = 'SET_CURRENT_KYC_TIER';
export const SET_LOADING = 'SET_LOADING';
